import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/modified-materials-store/useModifiedMaterialsStore.ts
var i = t(r((e, t) => ({
	modifiedMaterialIds: [],
	addModifiedMaterialId: (n) => {
		let r = t().modifiedMaterialIds;
		r.includes(n) || e({ modifiedMaterialIds: [...r, n] });
	},
	removeModifiedMaterialId: (n) => {
		let r = t().modifiedMaterialIds;
		r.includes(n) && e({ modifiedMaterialIds: r.filter((e) => e !== n) });
	},
	clear: () => {
		e({ modifiedMaterialIds: [] });
	}
}))), a = (t) => e(i, n(t));
//#endregion
export { i as modifiedMaterialsStore, a as useModifiedMaterialsStore };
